import { gql } from '@urql/core';
import { createQueryKeys } from '@lukemorales/query-key-factory';

export const billingFeatureKeys = createQueryKeys('billing', {
  pricingGrid: null,
});

export const pricingGridQuery = () => ({
  ...billingFeatureKeys.pricingGrid,
  meta: {
    query: gql`
      query PricingGrid {
        pricingGrid {
          plans {
            name
            label
            monthly {
              price
              stripeId
              semrushId
              recordingsAddon {
                productId
                planSlug
                stripeId
                tiers {
                  upTo
                  flatAmount
                }
              }
            }
            yearly {
              price
              stripeId
              semrushId
              recordingsAddon {
                productId
                planSlug
                stripeId
                tiers {
                  upTo
                  flatAmount
                }
              }
            }
            features
          }
          currentPlan
          showAddOnHeatmaps
          availableIntervals
          paymentProvider
        }
      }
    `,
  },
});
